export default "__VITE_ASSET__BC539lyO__"